module.exports = __webpack_public_path__ + "static/media/aboutUs.423e919e.svg";